export const fmtBigInteger = (n: number) => {
  n = Math.round(n);
  switch (true) {
    case n >= 1000000000000000:
      return ">999T";
    case n >= 1000000000000:
      return `${Math.round(n / 1000000000000)}T`;
    case n >= 1000000000:
      return `${Math.round(n / 1000000000)}B`;
    case n >= 1000000:
      return `${Math.round(n / 1000000)}M`;
    case n >= 1000:
      return `${Math.round(n / 1000)}K`;
  }
  return String(n);
};

export function fileSizeToString(size: number) {
  const i = size <= 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return `${(size / Math.pow(1024, i)).toFixed(2)} ${["B", "kB", "MB", "GB", "TB"][i]}`;
}

export function toISO8601Date(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function toReadableDate(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}.${month}.${year}`;
}

export function calculateGridItemSize(amount: number): number {
  if (amount > 8) return 2;

  return Math.floor(12 / Math.ceil(amount / 2));
}
